import { createContext, useContext } from 'react';
import { FlexibleStepperContextProps } from './types';

export const FlexibleStepperContext =
  createContext<FlexibleStepperContextProps>({
    isFirstStep: true,
    isLastStep: true,
    moveBackward: () => {},
    moveForward: () => {},
    restoreTo: (moveTo: number) => {
      console.log(moveTo);
    },
    step: 0,
    totalSteps: 0,
    initialStep: 0,
  });

export const useFlexibleStepper = () => {
  const stepperContext = useContext(FlexibleStepperContext);

  return stepperContext;
};
